<div class="main-section cx-one-ui">
    <div class="form-container cx-one-ui">
        <form [formGroup]="coalesceForm" id="reporting-set-data-field" *ngIf="showFields">
            <div class="input-field">
                <label for="add-field" id="add-field-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Add_Field">ADD FIELDS</label><span class="field-required"> * </span>
                <div class="row list-item" *ngFor="let item of parentData?.childs">
                    <ng-container *ngTemplateOutlet="addedList; context: { $implicit: item }"> </ng-container>
                </div>
                <div class="row list-item">
                    <ng-container *ngTemplateOutlet="emptyList"> </ng-container>
                </div>
            </div>
        </form>
    </div>
</div>
<ng-template #addedList let-item>
    <div class="col-10 add-field-box">
        <p class="row ellipsis-text" title="{{item?.name}}">{{item?.name}}</p>
    </div>
    <div class="col-2 cursor-pointer icon-container">
        <svg class="icon edit-icon" (click)="editExist(item)">
            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
        </svg>
    </div>
</ng-template>
<ng-template #emptyList>
    <div class="col-10 add-field-box">
        <p class="row text-color" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Input_Field_Placeholder">Add
            input</p>
    </div>
    <div class="col-2 cursor-pointer icon-container">
        <svg class="icon add-icon icon-14" (click)="addNewField()">
            <use href="../App_Themes/CXone/icons/add.svg#add"></use>
        </svg>
    </div>
</ng-template>
